import styled from 'styled-components';

export const StyledPercentageSlider = styled.div`
  margin-top: 3rem;
`;

export const StyledSliderHandler = styled.div`
  pointer-events: none;
  & .MuiSlider-rail {
    background: #a3a3a3;
  }
  & .MuiSlider-track {
    background: #a3a3a3;
  }
  & .MuiSlider-thumb {
    background: #a3a3a3;
    pointer-events: all;
    &:last-child {
      display: none;
    }
  }
`;

export const StyledTrackPart = styled.li`
  width: ${props => `${props.value}%`};
  background-color: ${props => props.color};
  position: relative;
`;

export const StyledTrackPartTitle = styled.header`
  position: relative;
  left: 2px;
  bottom: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledTrackPartValue = styled.div`
  color: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  position: absolute;
`;

export const StyledTrack = styled.ul`
  width: 100%;
  height: 30px;
  display: flex;
  margin: 0;
  padding: 0;
  list-style-type: none;
`;
